import React from "react";

const PromoArea = () => {
  return (
    <section className="gauto-promo-area">
      <div className="container">
        <div className="row">

          {/* Left Image */}
          <div className="col-md-6">
            <div className="promo-box-left">
              <img src="/img/toyota-offer-2.png" alt="Shambhu Cabs Promo" />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-md-6">
            <div className="promo-box-right">
              <h3>Book Your Ride with Shambhu Cabs Today!</h3>
              <p className="text-white">
                Enjoy safe, reliable, and comfortable taxi services for city rides, airport transfers, and outstation trips. Travel with confidence and convenience.
              </p>
              <a href="/booking" className="gauto-btn">
                Book Now
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PromoArea;
